import React from 'react';
import '../styles/PhoneNumberInput.css';
import { Input } from '../components';

function PhoneNumberInput(props) {
    const phoneNumber = props.phoneNumber;
    const onChangePhoneNumber = props.onChangePhoneNumber;
    return (
        <div className="phone-number-input-container">
            <Input
                label={"Phone number"}
                labelType={"default"}
                info={false}
                value={phoneNumber}
                onChange={(text) => onChangePhoneNumber(text.target.value)}
                placeholder={"(555) 555-5555"}
                type="text"
                leftUnit={null}
                rightUnit={null}
                unitSwitch={false}
                leftUnitSelected={true}
                unitSwitchFunc={null}
                disabled={false}
                multiline={false}
                error={false}
                onMouseEnter={null}
                onMouseLeave={null}
                reset={false}
                resetFunc={null}
                resetPosition={null}
                focusMultiline={false}
                prompt={false}
            />
        </div>
    )
};

export default PhoneNumberInput;